/**
 * API temporal contract: stored LocalDateTime values are UTC wall-clock.
 * Naive ISO strings (no Z / offset) are therefore interpreted as UTC.
 * Once parsed, use Date#toLocale* / Intl for local client display.
 */

function hasExplicitZone(raw) {
  return /[zZ]$/.test(raw) || /[+-]\d{2}:?\d{2}$/.test(raw);
}

/**
 * @param {string|number|Date|null|undefined} value
 * @returns {Date|null}
 */
export function parseApiDate(value) {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  if (hasExplicitZone(raw)) {
    const date = new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const date = new Date(`${raw}T00:00:00.000Z`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,9})?)?$/.test(normalized)) {
    const date = new Date(`${normalized}Z`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const fallback = new Date(raw);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

/** @returns {number} epoch ms, or NaN when unparseable */
export function parseApiDateMs(value) {
  const date = parseApiDate(value);
  return date ? date.getTime() : Number.NaN;
}
